import React, { FunctionComponent } from 'react';
import { useClasses } from 'app/utils/css';

interface IProps {
  color: string;
}

const Badge: FunctionComponent<IProps> = ({
  color,
  children,
}) => {
  const css = useClasses({
    badge: {
      display: 'inline-flex',
      background: color,
      padding: '7px',
      fontSize: '12px',
      flexShrink: 0,
    },
  });
  return (
    <span className={css.badge}>{children}</span>
  );
};

export default Badge;
